import React from "react";

export const RequiredLabel = () => {
    return <span className="required-label"> * </span>;
};
